/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".disable-class[_ngcontent-%COMP%]{opacity:.6;pointer-events:none}.button-width[_ngcontent-%COMP%]{min-width:350px;width:100%}@media screen and (min-width:1079px) and (max-width:1200px){.button-width[_ngcontent-%COMP%]{min-width:250px}}@media screen and (min-width:900px) and (max-width:1078px){.button-width[_ngcontent-%COMP%]{min-width:150px}}"];
export { styles as styles };
